import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';
import React, { InputHTMLAttributes } from 'react';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './textInput.css';

export type TextInputProps = {
  fill?: boolean;
  minWidth?: Exclude<Property.MinWidth, 0>;
} & ComponentPropsWithoutStyles<InputHTMLAttributes<HTMLInputElement>>;

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { fill, minWidth, type, children, ...props },
  ref,
) {
  return (
    <input
      type={type || 'text'}
      className={fill ? styles.variant.filled : styles.variant.inline}
      style={{
        ...assignInlineVars({
          [styles.minWidthVar]: minWidth ?? 'unset',
        }),
      }}
      ref={ref}
      {...props}
    >
      {children}
    </input>
  );
});
